// extracted by mini-css-extract-plugin
export default {"root":"wWpp0_wWpp0","overlay":"fHWhy_fHWhy","overlayContent":"d7Lbs_d7Lbs"};